import { createFileRoute } from "@tanstack/react-router";
import HowToSeeAPsychiatristPage from "@/pages/articles/HowToSeeAPsychiatristPage";
export const Route = createFileRoute("/how-to-see-a-psychiatrist")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "How to See a Psychiatrist: A Step-by-Step Guide | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "How to see a psychiatrist for depression: insurance, referrals, wait times, and what to expect at your first visit in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "How to See a Psychiatrist: A Step-by-Step Guide | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "How to see a psychiatrist for depression: insurance, referrals, wait times, and what to expect at your first visit in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/how-to-see-a-psychiatrist",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-to-see-a-psychiatrist",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowToSeeAPsychiatristPage />;
}
